export default __webpack_public_path__ + "static/media/nodejs.2e8eec5f.svg";